"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var unescape_1 = tslib_1.__importDefault(require("lodash/unescape"));
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var DEFAULT_DISABLED_COLOR = "#CCCCCC";
var LegendItem = /** @class */ (function (_super) {
    tslib_1.__extends(LegendItem, _super);
    function LegendItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegendItem.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        var _d = this.props, item = _d.item, width = _d.width, _e = _d.enableBorderRadius, enableBorderRadius = _e === void 0 ? false : _e, theme = _d.theme;
        var disabledColor = (_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.complementary) === null || _b === void 0 ? void 0 : _b.c5) !== null && _c !== void 0 ? _c : DEFAULT_DISABLED_COLOR;
        var iconStyle = {
            borderRadius: enableBorderRadius ? "50%" : "0",
            backgroundColor: item.isVisible ? item.color : disabledColor
        };
        // normal state styled by css
        var nameStyle = item.isVisible
            ? {}
            : {
                color: disabledColor
            };
        var style = width ? { width: width + "px" } : {};
        var onItemClick = function () {
            return _this.props.onItemClick(item);
        };
        return (react_1["default"].createElement("div", { style: style, className: "series-item", onClick: onItemClick },
            react_1["default"].createElement("div", { className: "series-icon", style: iconStyle }),
            react_1["default"].createElement("div", { className: "series-name", style: nameStyle, title: unescape_1["default"](item.name) }, item.name)));
    };
    return LegendItem;
}(react_1["default"].Component));
exports["default"] = sdk_ui_theme_provider_1.withTheme(LegendItem);
//# sourceMappingURL=LegendItem.js.map